import React from 'react'

const tradeComponent = () => {
  return (
    <div>tradeComponent</div>
  )
}

export default tradeComponent